import React, { useCallback, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ButtonGroup, Button } from '@appcues/sonar';
import { Heading, Input, Modal, ModalHeader } from 'ext/components/ui';
import { spoof, selectSpoofError } from 'entities/auth';
import { Body, ErrorMessage } from './styled';

export function SpoofingModal({ onClose, onSpoof, visible, spoofError }) {
  const [value, setValue] = useState('');
  const [pending, setPending] = useState(false);

  // Reset pending state when spoof fails
  useEffect(() => {
    if (spoofError) {
      setPending(false);
    }
  }, [spoofError]);

  const handleChange = useCallback(event => {
    setValue(event.target.value);
  }, []);

  const handleSpoof = useCallback(
    event => {
      event.preventDefault();

      if (!pending) {
        setPending(true);
        onSpoof(value);
      }
    },
    [onSpoof, pending, value]
  );

  return (
    <Modal onClose={onClose} visible={visible} theme="light">
      <ModalHeader>
        <Heading>Spoof Account</Heading>
        <ModalHeader.Close onClose={onClose} />
      </ModalHeader>

      <Body as="form" onSubmit={handleSpoof}>
        <Input
          onChange={handleChange}
          placeholder="Enter account ID to spoof"
          value={value}
        />

        {spoofError && <ErrorMessage>{spoofError}</ErrorMessage>}

        <ButtonGroup>
          <Button variant="tertiary" onClick={onClose} type="button">
            Cancel
          </Button>
          <Button
            disabled={!value || pending}
            variant="primary"
            onClick={handleSpoof}
            onSubmit={handleSpoof}
            type="button"
          >
            Spoof
          </Button>
        </ButtonGroup>
      </Body>
    </Modal>
  );
}

SpoofingModal.propTypes = {
  onClose: PropTypes.func,
  onSpoof: PropTypes.func,
  visible: PropTypes.bool,
  spoofError: PropTypes.string,
};

const mapStateToProps = state => ({
  spoofError: selectSpoofError(state),
});

const mapDispatchToProps = {
  onSpoof: spoof,
};

export default connect(mapStateToProps, mapDispatchToProps)(SpoofingModal);
